import { createRoot } from "react-dom/client";
import Root from "./Root.tsx";
import { initSentry } from "./core/sentry";
import "./index.css";
import "./i18n/config";

initSentry();
createRoot(document.getElementById("root")!).render(<Root />);
